export default "__VITE_ASSET__TppIgitY__"